import React from "react";
import { ItemPeek } from "./ItemPeek";
import StatusBadge from "../ui/StatusBadge";

export function FlowCard({ item, positionClass, isActive, onOpen, onClose, onMore, onAddToBasket, isItemInBasket }) {
  const activeImage =
    item.images && item.images.length
      ? item.images[item.activeImageIndex] || item.images[0]
      : null;
  const imageSrc = activeImage ? activeImage.src : item.imageSrc;
  const rawSvg = item.maskSvg || "";
  const svgMarkup = rawSvg.replace(/<\?xml[\s\S]*?\?>\s*/i, "");
  const statusForBadge = (item.status || "available").toLowerCase();
  
  const handleOpen = (event) => {
    event.preventDefault();
    const isMobileViewport =
      typeof window !== "undefined" &&
      window.matchMedia("(max-width: 640px)").matches;
    const shouldShowDetailsImmediately =
      isMobileViewport && !isActive;
    if (shouldShowDetailsImmediately) {
      onMore?.(item);
      return;
    }
    if (item.maskSvg) {
      const hit = event.target.closest(".g-flow__mask svg path");
      if (!hit) return;
    }
    if (isActive) {
      onClose?.();
      return;
    }
    onOpen?.(item);
  };

  return (
    <a
      href="#"
      className={`g-flow__card${positionClass ? ` ${positionClass}` : ""}${
        isActive ? " is-peek-open" : ""
      }`}
      js-flow-card="true"
      js-transition-trigger="true"
      onClick={handleOpen}
    >
      {isActive ? (
        <ItemPeek
          item={item}
          className="g-flow__peek"
          onClose={onClose}
          onMore={() => onMore?.(item)}
          onAddToBasket={onAddToBasket}
          isItemInBasket={isItemInBasket}
        />
      ) : null}
      <div
        className="g-flow__mask"
        js-flow-mask="true"
        data-title={item.title}
        data-author={item.author}
        dangerouslySetInnerHTML={{ __html: svgMarkup }}
      >
      </div>
      {imageSrc ? (
        <img src={imageSrc} loading="lazy" alt={item.title} />
      ) : null}
      <div className="g-flow__status">
        <StatusBadge status={statusForBadge} className="g-flow__status-badge" />
      </div>
    </a>
  );
}
